import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { RoleGuard } from 'app/core/auth/guards/role.guard';
import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'dashboard'},

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboard'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: '404', loadChildren: () => import('app/modules/errors/404/404.routes')},
            { path: '403', loadChildren: () => import('app/modules/errors/403/403.routes')},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: 'agendas', loadChildren: () => import('app/modules/admin/appointment/appointment.routes')},
            {path: 'convenios', loadChildren: () => import('app/modules/admin/agreements/agreements.routes')},
            {path: 'dashboard', loadChildren: () => import('app/modules/dashboards/dashboards.routes')},
            {path: 'especialidades', loadChildren: () => import('app/modules/admin/specialties/specialties.routes')},
            {path: 'especialistas', loadChildren: () => import('app/modules/admin/specialists/specialists.routes')},
            {path: 'examenes', loadChildren: () => import('app/modules/admin/laboratory/exams/exams.routes')},
            {path: 'pacientes', loadChildren: () => import('app/modules/admin/patients/patients.routes')},
            {path: 'perfil', loadChildren: () => import('app/modules/profile/profile.routes')},
            {path: 'plantillas-reportes', loadChildren: () => import('app/modules/admin/report-templates/report-templates.routes')},
            {path: 'reportes-medicos', loadChildren: () => import('app/modules/admin/medical-reports/medical-reports.routes')},
            {path: 'pruebas', loadChildren: () => import('app/modules/admin/laboratory/exams/types/types.routes')},
            {path: 'rayos-x', loadChildren: () => import('app/modules/dashboards/rx/rx.routes')},
            {path: 'usuarios', loadChildren: () => import('app/modules/admin/users/users.routes')},
        ]
    },

    // Cualquier URL que no case con nada acaba en la pantalla 404 (D23).
    // Va la ultima: como comodin, se traga todo lo que llegue hasta aqui.
    {path: '**', redirectTo: '404'}
];
